import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const SUBMIT_WHS_REVIEW = gql`
  mutation DeliveryMutation($operatorName: String) {
    result: submitWhsReview(operatorName: $operatorName) {
        success
    }
  }
`;

interface SubmitWhsReviewResponse {
    result: {
        success: boolean;
    };
}

export const handleSubmitWhsReview = async (operatorName?: string | null): Promise<boolean>  => {
    const { data } = await client.mutate<SubmitWhsReviewResponse>({
        mutation: SUBMIT_WHS_REVIEW,
        variables: { operatorName: operatorName || null }
    });
    return data?.result?.success || false;
};